import { useEffect } from 'react';
import { useLocation } from 'react-router';
import { getConfig } from '../../public/site/configStore.js';
import { atContext, atType, queryInput } from '../constants/namingConventionVariables.js';
import { paths } from '../constants/pathVariables.js';
import { isInBrowser } from '../utils/ssrUtils.js';

const getFrontPageJsonLd = (siteBaseUrl: string) =>
  JSON.stringify({
    [atContext]: 'https://schema.org',
    [atType]: 'WebSite',
    name: 'Elisa Yrityksille',
    url: `${siteBaseUrl}/`,
    potentialAction: {
      [atType]: 'SearchAction',
      target: {
        [atType]: 'EntryPoint',
        urlTemplate: `${siteBaseUrl}/haku?q={search_term_string}`,
      },
      [queryInput]: 'required name=search_term_string',
    },
  });

const getPageJsonLd = (siteBaseUrl: string, pagePath?: string) => {
  switch (pagePath) {
    case '/':
      return getFrontPageJsonLd(siteBaseUrl);
    default:
      return '';
  }
};

const isIdeatPath = (pathname: string) => pathname === paths.IDEAT || pathname.startsWith(`${paths.IDEAT}/`);

export const setHeadJsonLd = (content: string) => {
  const jsonLdScriptElement = isInBrowser() ? document.getElementById('head-json-ld') : null;
  if (jsonLdScriptElement) {
    jsonLdScriptElement.textContent = content;
  }
};

// TODO we should probably move this whole thing to CMS meta
export const useHeadJsonLd = () => {
  const { pathname } = useLocation();
  const { siteBaseUrl } = getConfig();

  useEffect(() => {
    if (isIdeatPath(pathname)) {
      return;
    }
    setHeadJsonLd(getPageJsonLd(siteBaseUrl, pathname));
  }, [pathname, siteBaseUrl]);
};
